// extracted by mini-css-extract-plugin
export default {"tab":"account-details_tab__E5iOP","row":"account-details_row__kaOq4","divider":"account-details_divider__P3ZeT","item":"account-details_item__rybiz"};